import '../premiumLanding.css';
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import AssignmentIcon from "@mui/icons-material/Assignment";
import InsightsIcon from "@mui/icons-material/Insights";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import ViewKanbanIcon from "@mui/icons-material/ViewKanban";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

const features = [
  {
    icon: <PeopleAltIcon />,
    titulo: "Gestión de Leads",
    desc: "Captura, organiza y da seguimiento a cada persona interesada. Pipeline visual tipo Kanban.",
    tag: "Más ventas",
  },
  {
    icon: <ViewKanbanIcon />,
    titulo: "Pipeline Visual",
    desc: "Mueve leads por etapas: Nuevo → Contactado → Interesado → Propuesta enviada → Venta. Personaliza tu kanban.",
    tag: "Claridad",
  },
  {
    icon: <NotificationsActiveIcon />,
    titulo: "Seguimiento Claro",
    desc: "Alertas automáticas de leads sin contactar. Nunca pierdas una oportunidad por olvido.",
    tag: "Cero fugas",
  },
  {
    icon: <AttachMoneyIcon />,
    titulo: "Control de Ventas",
    desc: "Registra pagos en efectivo y transferencia. Ve tus ingresos por día, vendedor y producto.",
    tag: "Más ingresos",
  },
  {
    icon: <InsightsIcon />,
    titulo: "Dashboard Analítico",
    desc: "Tasa de conversión, embudo de ventas, rendimiento por canal y por vendedor. KPIs clave.",
    tag: "Decisiones",
  },
  {
    icon: <AssignmentIcon />,
    titulo: "Resumen Automático",
    desc: "Métricas diarias generadas automáticamente: mensajes, atendidos, ventas, ingresos.",
    tag: "Control total",
  },
];

const useCases = [
  "Academias de danza",
  "Gimnasios y crossfit",
  "Cursos y talleres",
  "Estudios de yoga / pilates",
  "Escuelas de idiomas",
  "Centros de capacitación",
];

export default function CoreBaseSections() {
  return (
    <>
      {/* PROBLEMA → SOLUCIÓN */}
      <section className="pl-section">
        <div className="pl-wrap">
          <div className="pl-problem-solution">
            <div className="pl-ps-col">
              <h3>¿Te suena familiar?</h3>
              <ul>
                {[
                  "Leads que se pierden porque nadie les dio seguimiento",
                  "No sabes cuánto vendiste hoy ni quién vendió más",
                  "Tu vendedora tiene todo en WhatsApp y tú no ves nada",
                  "No sabes qué canal trae más clientes",
                  "Cada día es un caos y no hay proceso claro",
                ].map((problem) => (
                  <li key={problem}>
                    <b>✗</b>
                    <span>{problem}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div className="pl-ps-col pl-ps-solution">
              <h3>Con CoreBase</h3>
              <ul>
                {[
                  "Cada lead tiene seguimiento claro",
                  "Dashboard con ventas en tiempo real",
                  "Ves quién vende, cuánto y por qué canal",
                  "Alertas cuando un lead está por perderse",
                  "Proceso claro: lead → contacto → inscripción → venta",
                ].map((solution) => (
                  <li key={solution}>
                    <b>✓</b>
                    <span>{solution}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* PARA QUIÉN */}
      <section className="pl-section pl-section-muted">
        <div className="pl-wrap">
          <div className="pl-section-head">
            <h2>¿Para quién es CoreBase?</h2>
            <p>
              Diseñado para negocios de servicios que atienden personas y necesitan
              controlar su flujo comercial.
            </p>
          </div>
          <div className="pl-usecase-grid">
            {useCases.map((item) => (
              <div key={item} className="pl-usecase">{item}</div>
            ))}
          </div>
        </div>
      </section>

      {/* FEATURES */}
      <section className="pl-section">
        <div className="pl-wrap">
          <div className="pl-section-head">
            <h2>Todo lo que necesitas para vender más</h2>
            <p>Cada módulo responde a una pregunta: ¿cómo esto hace que tu negocio gane más dinero?</p>
          </div>
          <div className="pl-feature-grid">
            {features.map((f) => (
              <div key={f.titulo} className="pl-feature-card">
                <span className="pl-feature-tag">{f.tag}</span>
                <div className="pl-feature-icon">{f.icon}</div>
                <h3>{f.titulo}</h3>
                <p>{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CANALES */}
      <section className="pl-section pl-section-muted">
        <div className="pl-wrap">
          <div className="pl-feature-grid" style={{ gridTemplateColumns: 'repeat(4, 1fr)', alignItems: 'center' }}>
            <div className="pl-usecase" style={{ padding: '24px 16px' }}>
              <WhatsAppIcon style={{ color: 'var(--primary)', fontSize: 28, marginBottom: 8 }} />
              <div style={{ fontWeight: 600 }}>WhatsApp</div>
            </div>
            <div className="pl-usecase" style={{ padding: '24px 16px' }}>
              <PeopleAltIcon style={{ color: 'var(--primary)', fontSize: 28, marginBottom: 8 }} />
              <div style={{ fontWeight: 600 }}>Presencial</div>
            </div>
            <div className="pl-usecase" style={{ padding: '24px 16px' }}>
              <TrendingUpIcon style={{ color: 'var(--primary)', fontSize: 28, marginBottom: 8 }} />
              <div style={{ fontWeight: 600 }}>Redes Sociales</div>
            </div>
            <div style={{ textAlign: 'left' }}>
              <h3 style={{ fontSize: 16, marginBottom: 8 }}>Mide qué canal convierte mejor</h3>
              <p style={{ fontSize: 14 }}>
                Registra de dónde viene cada lead y CoreBase te dice cuál canal genera más
                inscripciones y más dinero.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
